import { Expose } from 'class-transformer'

export class StorageSizeHistoryDataType {
  @Expose() value: number

  @Expose() size: number
}
